export default {
  //common
  passwordLabel: "पासवर्ड",
  confirmPassword: "पासवर्ड की पुष्टि करें",
  login_Button: "लॉगिन",
  login_id_required: "लॉगिन आईडी आवश्यक है",
  password_required: "पासवर्ड आवश्यक है",
  forgot_Password: "पासवर्ड भूल गए?",
  forgot_PasswordPage: "पासवर्ड भूल गए",
  descLogin: "‘लॉगिन’ पर क्लिक करके, आप स्वीकार करते हैं कि आपने समीक्षा की है",
  agreeLogin: "और हमारी शर्तों से सहमत हैं",
  termsConditions: "नियम और शर्तें",
  privacyLogin: "गोपनीयता नीति",
  disclaimer: "गोपनीयता नीति",
  tipsSafeBanking: "सुरक्षित बैंकिंग के लिए सुझाव",
  firstTimeUser: "पहली बार उपयोग कर रहे हैं",
  registerHere: "यहां पंजीकरण करें",
  accountNumberLabel: "खाता संख्या",
  selectAccountNumber: "खाता संख्या चुनें",
  accountHolderName: "खाता धारक का नाम",
  account_required: "खाता संख्या आवश्यक है",
  accountType_required: "खाता प्रकार आवश्यक है",
  accountHolderName_required: "खाता धारक का नाम आवश्यक है",
  messageNoRecordFound: "क्षमा करें, कोई मिलते-जुलते रिकॉर्ड नहीं मिले",
  accountNumberLabelPlaceholder: "खाता संख्या चुनें",

  //Corporate Login
  domainId: "डोमेन आईडी/कंपनी आईडी",
  useridCor: "यूज़र आईडी",
  useridCorRequired: "यूज़र आईडी आवश्यक है",
  userIdPlaceholder: "आपकी यूज़र आईडी",
  domainIdRequired: "डोमेन आईडी/कंपनी आईडी आवश्यक है",
  PasswordCor: "पासवर्ड",
  confirm_PasswordCor: "पासवर्ड की पुष्टि करें",
  PasswordCorRequired: "पासवर्ड आवश्यक है",
  confirmPasswordCorRequired: "पासवर्ड की पुष्टि आवश्यक है",
  patternMessage: "पासवर्ड आवश्यकताओं को पूरा नहीं करता है",
  corForgotMsgHeading: "कृपया डोमेन आईडी/कंपनी आईडी दर्ज करें, हम पंजीकृत मोबाइल नंबर पर OTP भेजेंगे",
  sendButton: "भेजें",

  //Register Login
  card_RegisterHeading: "पंजीकरण करें",
  card_WithCard: "कार्ड के साथ",
  Card_withCustNo: "ग्राहक संख्या के साथ",
  Card_CustomerNo: "ग्राहक संख्या",
  Card_CustomerNoRequired: "ग्राहक संख्या आवश्यक है",
  Card_CardNo: "कार्ड संख्या",
  Card_CardNoRequired: "कार्ड संख्या आवश्यक है",
  Card_CVV: "सीवीवी",
  Card_CVVRequired: "सीवीवी आवश्यक है",
  CVV_Format: "कृपया मान्य सीवीवी प्रारूप दर्ज करें",
  Card_expiryDate: "समाप्ति तिथि",
  accept_msg: "मैं स्वीकार करता/करती हूँ",
  card_termscondition: "नियम और शर्तें",
  card_registerButton: "पंजीकरण करें",
  withCustNo: "कृपया ग्राहक संख्या दर्ज करें, हम पंजीकृत मोबाइल नंबर पर ओटीपी भेजेंगे",


  //Account Statement
  fromDate: "प्रारंभ तिथि",
  toDate: "अंतिम तिथि",
  buttonSubmit: "जमा करें",
  buttonReset: "रीसेट करें",
  buttonCancel: "रद्द करें",
  buttonAccept: "स्वीकार करें",
  BalanceLabel: "शेष राशि",
  accountTypeLabel: "खाता प्रकार",
  noDataAvailable: "कोई डेटा उपलब्ध नहीं है",
  processPDF: "पीडीएफ प्रोसेस करें",
  viewPDF: "पीडीएफ देखें",

  statementList: "विवरण सूची",
  column_download: "डाउनलोड",
  statement_columnFromDate: "प्रारंभ तिथि",
  statement_columnToDate: "समाप्ति तिथि",
  statement_columnFileName: "फ़ाइल नाम",
  statement_columnStatus: "स्थिति",
  statement_columnAccNumber: "खाता संख्या",
  statement_createdBy: "निर्माता",
  statement_createdDate: "निर्माण तिथि",
  statementDownloadInfo: "प्रिय ग्राहक, गोपनीयता बनाए रखने और आपकी निजता की सुरक्षा हेतु आपका ई-विवरण पासवर्ड संरक्षित है।",
  estatementPssword: "ई-विवरण पासवर्ड:",
  downloadInfoThirdLine: "अपने खाता ई-विवरण को देखने के लिए, कृपया पासवर्ड के रूप में अपना ग्राहक संख्या दर्ज करें।",
  forEx: "उदाहरण के लिए:",
  downloadInfoCustomer: "- यदि आपकी ग्राहक संख्या है",
  downloadCustNo: "123456",
  downloadCustNo4digit: "123456",
  downloadInfoLast: ", तो आपका पासवर्ड होगा",
  downloadExCustNo: "004561",
  downloadExCustNo4digit: "4561",
  downloadConfirmationMessage: "क्या आप वाकई अपना ई-विवरण डाउनलोड करना चाहते हैं?",
  NoButtonDownload: "नहीं",
  YesButtonDownload: "हाँ",

  //Header
  Header_IB: "इंटरनेट बैंकिंग में आपका स्वागत है",
  Header_CB: "कॉर्पोरेट बैंकिंग में आपका स्वागत है",
  Header_lastlogin: "पिछला लॉगिन",

  login_enterdetailsheading: "कृपया अपनी जानकारी दर्ज करें।",
  login_LoginIdLabel: "लॉगिन आईडी",
  login_validationLoginId: "आईडी में 4 बड़े अक्षर और 8 अंक होने चाहिए",
  login_forgotPassword: "पासवर्ड भूल गए?",
  login_termsText: "‘लॉगिन’ पर क्लिक करके, आप स्वीकार करते हैं कि आपने पढ़ा है",
  login_agreetext: "और सहमत हैं",
  login_termsCondition: "नियम और शर्तें",
  login_privacypolicy: "गोपनीयता नीति",
  login_disclaimer: "अस्वीकरण",
  login_tipsforsafe: "सुरक्षित बैंकिंग के लिए सुझाव",
  login_copyright: "कॉपीराइट 2025 | सर्वाधिकार सुरक्षित",
  login_footerDeveloped: "विकसित किया गया",
  login_footerSaraswat: "सरस्वत इन्फोटेक प्राइवेट लिमिटेड",

  //FORGET Password internet banking
  forgetpassword: "पासवर्ड भूल गए",
  forgetpassword_message: "कृपया ग्राहक संख्या दर्ज करें, हम पंजीकृत मोबाइल नंबर पर ओटीपी भेजेंगे",
  forgetpassword_Loginid: "लॉगिन आईडी",
  forgetpassword_send: "भेजें",

  resetPassword: "पासवर्ड रीसेट करें",

  //OTP internet banking
  otp_loginHeading: "इंटरनेट बैंकिंग में लॉगिन करें",
  otp_enterHeading: "चार अंकों का ओटीपी दर्ज करें",
  otp_messageError: "आपके पास",
  otp_messageErrorleftMessage: "प्रयास शेष हैं",

  //Home.js
  home_HeadingAccountDetails: "खाता विवरण",
  home_HeadingAccountStatement: "खाता विवरण-पत्र",
  home_HeadingStatement: "सारांश",
  home_financial: "वित्तीय अवलोकन",
  miniStatementSummary: "मिनी स्टेटमेंट",
  laonSummary: "ऋण",
  loanStmtHeading: "ऋण विवरण-पत्र",
  sumMiniStmtColumntransDate: "लेन-देन की तिथि",
  sumMiniStmtColumnParticulars: "विवरण",
  sumMiniStmtColumnStatus: "स्थिति",
  sumMiniStmtColumnAmount: "राशि",

  //Account.js
  AccountStatementsHeading: "खाता विवरण-पत्र",
  PerSetCustLimit: "ग्राहक सीमा निर्धारित करें",

  //Account Main Heading
  accountSummary_Heading: "खाता शेष सारांश",
  accountTable_Heading: "खाता धारक का नाम",
  account_Statement: "खाता विवरण-पत्र",
  account_customerLimit: "ग्राहक सीमा निर्धारित करें",
  accountTable_accountName: "खाता संख्या",
  accountTable_accountType: "खाता प्रकार",
  accountTable_Balance: "शेष राशि",
  accountTable_Details: "विवरण",
  accountTable_Branchcode: "शाखा कोड",
  account_miniStatement: "मिनी स्टेटमेंट",
  account_Loan: "ऋण",
  ministatement_account: "खाता चुनें",
  statement_Heading: "लेन-देन विवरण-पत्र",
  transaction_Date: "लेन-देन की तिथि",

  //Customer Limit
  accountSetCust_Heading: "ग्राहक सीमा निर्धारित करें",
  customerNoSetLimit: "ग्राहक संख्या",
  selectCustomerNoSetLimit: "ग्राहक संख्या चुनें",
  custNoIsrequired: "ग्राहक संख्या आवश्यक है",
  neftCustLimit: "एनईएफटी",
  rtgsCustLimit: "आरटीजीएस",
  internalCustLimit: "आंतरिक",
  perDayTranxLimit: "प्रति दिन लेन-देन सीमा",
  currentLimit: "वर्तमान सीमा",
  perDayMaxTranxLimit: "प्रति दिन अधिकतम लेन-देन राशि:",


  //AccountStatement
  noRowsDisplayMessage: "कोई पंक्तियाँ नहीं",
  recentTransaction: "हाल की लेन-देन",
  accStmtSelectAcc: "खाता चुनें",
  transStatementHeading: "लेन-देन विवरण-पत्र",
  accStmtColumntransDate: "लेन-देन की तिथि",
  accStmtColumnParticulars: "विवरण",
  accStmtColumnStatus: "स्थिति",
  accStmtColumnAmount: "राशि",

  //Beneficiary
  column_nickname: "उपनाम",
  column_name: "नाम",
  column_acconno: "खाता संख्या",
  column_Ifsc: "आईएफएससी",
  column_createdDatenadTime: "तिथि और समय",
  column_delete: "हटाएं",
  add_Benficiary: "लाभार्थी जोड़ें",

  //Beneficiary Master
  BeneAccountNumber: "खाता संख्या",
  BeneAccountNumberReq: "खाता संख्या आवश्यक है",
  BeneIFSCCode: "आईएफएससी कोड",
  BeneIFSCCodeReq: "आईएफएससी कोड आवश्यक है",
  validIFSCCode: "कृपया मान्य आईएफएससी कोड दर्ज करें",
  BeneNickname: "उपनाम",
  BeneNicknameReq: "उपनाम आवश्यक है",
  BeneFullName: "पूरा नाम",
  BeneFullNameReq: "पूरा नाम आवश्यक है",
  BeneMobileNumber: "मोबाइल नंबर",
  buttonReset: "रीसेट करें",
  buttonAddBeneficiary: "लाभार्थी जोड़ें",
  beneficiary_Verified: "लाभार्थी सत्यापित",
  next_Button: "आगे",
  pattern_nickname: "कृपया अक्षरों और अंकों का संयोजन दर्ज करें",
  acc_HolderName: "खाता धारक का नाम",
  acc_HolderNameReq: "खाता धारक का नाम आवश्यक है",
  mobile_Valid: "कृपया मान्य मोबाइल नंबर दर्ज करें",

  //other
  heading_otherbank: "अन्य बैंक लाभार्थी सूची",
  heading_withinBank: "बैंक के भीतर लाभार्थी सूची",

  //Other Bank Corporate
  headingOtherBank: "अन्य बैंक का लाभार्थी जोड़ें",

  // Within Bank
  headingWithinBank: "बैंक के भीतर लाभार्थी जोड़ें",
  Cor_accountholdname: "सीबीएस में खाता धारक का नाम",
  Validate: "सत्यापित करें",

  //Transfer History
  transferHistoryHeading: "हस्तांतरण इतिहास",
  transferReport: "लेन-देन रिपोर्ट",
  column_ViewReceipt: "रसीद देखें",
  column_TransTransactionDate: "लेन-देन की तिथि",
  column_TransactionTyep: "लेन-देन का प्रकार",
  column_RemitterAcNo: "प्रेषक खाता संख्या",
  column_BeneficiaryAcNo: "लाभार्थी खाता संख्या",
  column_BeneficiaryIFSC: "लाभार्थी आईएफएससी",
  column_BeneName: "लाभार्थी नाम",
  column_BeneAmount: "लेन-देन राशि",
  column_BeneRRN: "आरआरएन",
  column_ResponseCode: "प्रतिक्रिया कोड",


  //Fund Transfer
  column_pay: "भुगतान करें",
  column_nickname: "उपनाम",
  column_name: "नाम",
  column_accountno: "खाता संख्या",
  column_ifsc: "आईएफएससी",
  column_status: "स्थिति",
  remitterDetails: "प्रेषक विवरण",
  availableBalance: "उपलब्ध शेष राशि:",
  beneficiaryDetails: "लाभार्थी विवरण",
  beneficiaryAccountNumber: "लाभार्थी खाता संख्या",
  beneficiaryAccountNumber_required: "लाभार्थी खाता संख्या आवश्यक है",
  beneficiaryIFSC: "लाभार्थी आईएफएससी",
  beneficiaryIFSC_required: "लाभार्थी आईएफएससी आवश्यक है",
  beneficiaryName: "लाभार्थी नाम",
  beneficiaryName_required: "लाभार्थी नाम आवश्यक है",
  transferDetails: "लेन-देन विवरण",
  amount: "राशि",
  amount_required: "राशि आवश्यक है",
  amount_validation: "कृपया मान्य राशि दर्ज करें",
  tpin: "टीपिन",
  tpin_required: "टीपिन आवश्यक है",
  tpin_info: "टीपिन केवल अंकों में होना चाहिए और कम से कम 4 अंक लंबा होना चाहिए",
  remark: "टिप्पणी",
  remark_required: "टिप्पणी आवश्यक है",
  continue_Button: "जारी रखें",

  //neft
  neft_mainHeading: "नेशनल इलेक्ट्रॉनिक फंड ट्रांसफर (NEFT)",
  neft_tableHeading: "लेन-देन के लिए लाभार्थी चुनें",

  //rtgs
  rtgs_heading: "रीयल टाइम ग्रॉस सेटलमेंट (RTGS)",
  rtgs_tableHeading: "लेन-देन के लिए लाभार्थी चुनें",
  validIFSC: "कृपया मान्य आईएफएससी कोड दर्ज करें",
  validAmount: "कृपया मान्य राशि दर्ज करें",

  //WithinBank
  withinbank_Heading: "बैंक के भीतर फंड ट्रांसफर",
  table_heading: "लाभार्थी सूची",

  //Self account
  main_heading: "स्वयं का खाता",

  //Personal Loans
  Per_loanMainHeading: "ऋण विवरण",
  per_loanSubHeading: "ऋण खाता सारांश",
  per_loanColView: "देखें",
  per_loanColDisbursement: "वितरण",
  per_loanColRepayment: "भुगतान",
  per_colLoanAccNo: "ऋण खाता संख्या",
  per_colLoanAmount: "ऋण राशि",
  per_colLoanBalance: "शेष राशि",
  per_colLoanEMI: "ईएमआई",
  per_colLoanIntRate: "ब्याज दर (%)",
  loans_AccountStatement: "खाता विवरण-पत्र",
  loans_paymentHeading: "ऋण भुगतान",
  loans_payNowButton: "अब भुगतान करें",
  loans_loanAccountNumber: "ऋण खाता संख्या",
  loans_loanAccountNumberRequired: "ऋण खाता संख्या आवश्यक है",
  loansPayment_Amount: "राशि",
  loansPayment_AmountRequired: "राशि आवश्यक है",
  loansPaymentTpin: "टीपिन",
  loansPaymentTPINPattern: "टीपिन केवल अंकों में होना चाहिए और कम से कम 4 अंक लंबा होना चाहिए",
  loansPaymentTpinRequired: "टीपिन आवश्यक है",
  loansPayment_Remark: "टिप्पणी",
  loansPayment_RemarkRequired: "टिप्पणी आवश्यक है",
  loansPayment_Apply: "आवेदन करें",
  customerNoLoans: "ग्राहक नाम/संख्या",
  customerNoLoansRequired: "ग्राहक नाम/संख्या आवश्यक है",
  customerNoLoansPlaceholder: "ग्राहक संख्या चुनें",
  loandisbursementDetails: "ऋण खातों का विवरण",
  loanCustomerName: "ग्राहक का नाम",
  sanctionAmount: "स्वीकृत राशि",
  SanctionDate: "स्वीकृति तिथि",
  TotalDisbursedAmount: "कुल वितरित राशि",
  DisbursedStatus: "वितरण स्थिति",
  Disbursementdate: "वितरण तिथि",
  InterestRateloancol: "ब्याज दर",
  DisbursementAmount: "वितरित राशि",
  DisbursementDetail: "वितरण विवरण",
  LoanBranchCode: "ऋण शाखा कोड",
  InterestRatepa: "ब्याज दर (% प्रति वर्ष)",
  LoanHolderName: "ऋण धारक का नाम",
  LoanAccountType: "खाता प्रकार",
  LoanAccountStatus: "खाता स्थिति",
  DisbursalStatus: "वितरण स्थिति",
  InstallmentStart: "किस्त प्रारंभ",
  OutstandingAmount: "बकाया राशि",
  CurrentMonthEMI: "वर्तमान माह की ईएमआई",
  InterestAppliedUptoDate: "ब्याज लागू तिथि तक",
  UnutilizedLimit: "अप्रयुक्त सीमा",
  ExpiryDate: "समाप्ति तिथि",

  // Repayment Details
  EffectiveDate: "प्रभावी तिथि",
  InstallmentAmount: "किस्त राशि",
  PrincipalAmount: "मूलधन राशि",
  InterestRecovered: "वसूल ब्याज",
  OSBalance: "बकाया शेष",
  RepaymentDetail: "भुगतान विवरण",


  //Deposit Personal
  deposit_AccountNo: "खाता संख्या",
  deposit_ineterestRate: "ब्याज दर",
  ineterst_Month: "माह",
  interest_Days: "दिन",
  interestDeposit_Rate: "ब्याज दर (%)",
  interestDeposit_Date: "ब्याज तिथि",
  interestDepositType: "जमा प्रकार",

  //Deposit
  depositheading: "जमा खाता विवरण",
  costumerNo: "ग्राहक संख्या",
  NodataAvailable: "कोई डेटा उपलब्ध नहीं है",
  receiptNo: "रसीद संख्या",
  dateOfReceipt: "रसीद की तिथि",
  principalAmount: "मूलधन/किस्त राशि",
  Balance_Deposit: "शेष राशि",
  InterestRate: "ब्याज दर (%)",
  maturityAmount: "परिपक्वता राशि",
  maturityDate: "परिपक्वता तिथि",
  LienAmount: "लीएन राशि",
  asOfDate: "दिनांक अनुसार",
  openDeposit_Heading: "नई जमा खोलें",

  //Statement
  statement_heading: "विवरण",
  date_message: "कृपया 31 दिनों की सीमा में कोई दिनांक चयन करें",
  view_Button: "देखें",
  openingBalance: "प्रारंभिक शेष:",
  dateColumn: "तिथि",
  particularColumn: "विवरण",
  instrumentsColumn: "इंस्ट्रूमेंट्स",
  drAmountColumn: "डेबिट राशि",
  crAmountColumn: "क्रेडिट राशि",
  totalAmount: "कुल राशि",

  //Cheque Request
  cheque_Heading: "चेकबुक अनुरोध",
  cheque_Delivery: "वितरण दिवस",
  cheque_noOfPassbook: "चेकबुक की संख्या",
   cheque_noOfPassbookNotZero:"पासबुक की संख्या शून्य नहीं हो सकती",
  cheque_maxAllowedValueIs3:"अधिकतम 3 चेक बुक की अनुमति है।",
  cheque_noOfPassbookRequired: "चेकबुक की संख्या आवश्यक है",
  cheque_deliveryRequired: "वितरण दिवस आवश्यक है",
  cheque_Confirmation: "क्या आप वाकई चेकबुक अनुरोध को आगे बढ़ाना चाहते हैं?",

  //Cheque Status
  cheque_StatusHeading: "चेकबुक स्थिति",
  cheque_no: "चेक संख्या",
  cheque_noRequired: "चेक संख्या आवश्यक है",

  //Profile
  profile_Title: "प्रोफ़ाइल सेटिंग्स",
  button_updateTPIN: "टीपिन अपडेट करें",
  button_updatePssword: "पासवर्ड अपडेट करें",
  button_forgotTPIN: "टीपिन भूल गए?",
  profile_PersonalDetails: "व्यक्तिगत विवरण",
  personalDetails_userName: "उपयोगकर्ता नाम",
  personalDetails_homeBranch: "होम ब्रांच",
  personalDetails_Address: "पता",
  personalDetails_homeAddressBranch: "होम ब्रांच पता",
  profile_ContactDetails: "संपर्क विवरण",
  contactNo: "संपर्क नंबर",
  email_Address: "ईमेल पता",
  communication_Address: "पत्राचार पता",
  profile_Documents: "दस्तावेज़",
  panCardNo: "पैन कार्ड संख्या",
  AadharCard: "आधार कार्ड संख्या",
  companyName: "कंपनी का नाम",

  //Update Tpin
  updateTpin: "टीपिन अपडेट करें",
  oldTpin: "पुराना टीपिन",
  oldTpinPlaceholder: "कृपया पुराना टीपिन दर्ज करें",
  tpin_required: "टीपिन आवश्यक है",
  tpinPattern: "कृपया मान्य टीपिन दर्ज करें",
  newTpin: "नया टीपिन",
  newTpinPlaceholder: "कृपया नया टीपिन दर्ज करें",
  confirmTpin: "टीपिन की पुष्टि करें",
  confirmTpinPlaceholder: "कृपया टीपिन की पुष्टि करें",
  tpinSubmit: "सबमिट",

  //updatePasswordModal
  updatePassword: "पासवर्ड अपडेट करें",
  passwordRequired: "पासवर्ड आवश्यक है",
  oldPassword: "पुराना पासवर्ड",
  oldPasswordPlaceholder: "कृपया पुराना पासवर्ड दर्ज करें",
  newPassword: "नया पासवर्ड",
  newPasswordPlaceholder: "कृपया नया पासवर्ड दर्ज करें",
  confirmPassword: "पासवर्ड की पुष्टि करें",
  confirmPasswordPlaceholder: "कृपया पासवर्ड की पुष्टि करें",
  update_SubmitButton: "सबमिट",

  //forgetTpinModal
  forgotTpinHeading: "टीपिन भूल गए",
  TpinOTP: "ओटीपी दर्ज करें",

  //Complaint Support
  complaint_Heading: "ग्राहक शिकायत स्थिति देखें",
  raiseComplaint_Button: "शिकायत दर्ज करें",
  complaintViewColumn: "देखें",
  complaintComaplinId: "शिकायत आईडी",
  complaintustomerNo: "ग्राहक संख्या",
  complaintMobileNo: "मोबाइल नंबर",
  comaplaintEmail: "ग्राहक ईमेल",
  complaintName: "नाम",
  complaintCategory: "श्रेणी",
  complaintSubject: "विषय",
  complaintMessage: "संदेश",
  complaintCreatedDate: "निर्माण तिथि",
  complaintStatus: "स्थिति",
  complaintResponsemsg: "उत्तर संदेश",
  complaintReplyBy: "उत्तर देने वाला",
  complaintReplyDt: "उत्तर तिथि",
  categoryRequired: "श्रेणी आवश्यक है",
  subjectRequired: "विषय आवश्यक है",
  messageRequired: "संदेश आवश्यक है",
  complaintResetButton: "रीसेट करें",
  complaintSubmitButton: "सबमिट करें",
  supportTeamHeading: "इंटरनेट बैंकिंग SIL सहायता टीम",
  Helpdesk: "हेल्पडेस्क",
  officeHours: "कार्यालय समय",
  bankTiming: "बैंक प्रत्येक रविवार और हर दूसरे व चौथे शनिवार को बंद रहता है",
  compaintAddress: "पता",
  complaintEmail: "ईमेल",

  //CORPORATEHOME
  Cor_AccountDetails: "खाता विवरण",
  cor_AccountStatementHeading: "खाता विवरण पत्रक",

  //Financial Overview
  financial_mainHeading: "बैंक खाता",
  finCol_AccHolderName: "खाताधारक का नाम",
  finCol_AccNo: "खाता संख्या",
  finCol_AccType: "खाता प्रकार",
  finCol_Balance: "शेष राशि",
  finCol_Details: "विवरण",
  finNoDataAvailable: "कोई डेटा उपलब्ध नहीं है",

  //Browse Beneficiary
  CorBrowseBeneficiary: "लाभार्थी सूची",
  CorBeneficiaryType: "लाभार्थी प्रकार",
  CorBeneficiaryTypeRequired: "लाभार्थी प्रकार आवश्यक है",
  CorAccHolderName: "खाताधारक का नाम",
  CorSubmitBene: "जमा करें",
  BrowseColNickname: "उपनाम",
  BrowseColName: "नाम",
  BrowseColAccountNumber: "खाता संख्या",
  BrowseColIFSC: "आईएफएससी",
  BrowseColDelete: "हटाएं",

  //Payments
  selfAccountTransfer: "स्वयं खाते में ट्रांसफर",
  fundTransferHeading: "फंड ट्रांसफर",
  col_srNo: "क्रमांक",
  col_TransDate: "लेन-देन की तारीख",
  col_rrnNo: "आरआरएन नंबर",
  col_tType: "लेन-देन का प्रकार",
  col_cbsreceivedDate: "सीबीएस प्राप्त तारीख",
  col_cbsSendDate: "सीबीएस भेजी गई तारीख",
  col_cbsrrnNo: "सीबीएस आरआरएन",
  col_narration: "विवरण",
  col_amountPayment: "राशि",
  col_RemAccountNo: "प्रेषक खाता संख्या",
  col_BeneficiaryAccNo: "लाभार्थी खाता संख्या",
  col_BeneficiaryIFSC: "लाभार्थी आईएफएससी",
  col_BeneficiaryName: "लाभार्थी का नाम",
  col_Remittercode: "प्रेषक कोड",
  col_RemitterMobileNo: "प्रेषक मोबाइल नंबर",
  col_Status: "स्थिति",
  transferType: "स्थानांतरण प्रकार",
  transferTypeReq: "स्थानांतरण प्रकार आवश्यक है",
  fromAccNo: "खाता संख्या से",
  BeneNickname: "लाभार्थी उपनाम",
  BeneAccountNo: "लाभार्थी खाता संख्या",
  BeneAccountNoReq: "लाभार्थी खाता संख्या आवश्यक है",
  BeneIFSCCode: "लाभार्थी आईएफएससी कोड",
  BeneIFSCCodeReq: "लाभार्थी आईएफएससी कोड आवश्यक है",
  BeneficiaryNameReq: "लाभार्थी का नाम आवश्यक है",
  BeneNicknamePattern: "लाभार्थी उपनाम अधिकतम 10 अंकों का होना चाहिए",
  BeneNicknameReq: "लाभार्थी उपनाम आवश्यक है",
  selectBeneNickname: "लाभार्थी उपनाम चुनें",
  transferMethod: "स्थानांतरण विधि",
  fundTransferTableHeading: "मंजूरी लंबित लेन-देन",
  bulkPaymentUploadHeading: "बल्क पेमेंट अपलोड",
  recentBulkUploadTransaction: "हाल की बल्क अपलोड लेन-देन",
  col_preview: "पूर्वावलोकन",
  col_fileName: "फ़ाइल का नाम",
  col_totalAmount: "कुल राशि",
  col_transferMethod: "हस्तांतरण विधि",
  col_bulkfromaccount: "खाते से",
  colCreatedBy: "बनाया गया द्वारा",
  colCreatedDate: "तिथि बनाई गई",
  col_bulkStatuys: "स्थिति",
  sampleFileCSV: "नमूना फ़ाइल CSV",
  sampleFileText: "नमूना फ़ाइल टेक्स्ट",
  resetButton: "रीसेट करें",
  submitBulkButton: "जमा करें",
  attachFileUpload: "फ़ाइल अटैच/अपलोड करें",

  // Checker Recent Transaction
  colRT_View: "देखें",
  colRT_TDate: "लेन-देन की तिथि",
  colRT_TType: "लेन-देन का प्रकार",
  colRT_Amount: "राशि",
  colRT_RRNNo: "RRN नंबर",
  colRT_RemAccNo: "भेजने वाले का खाता नंबर",
  colRT_BenName: "प्राप्तकर्ता का नाम",
  colRT_BenAccNo: "प्राप्तकर्ता का खाता नंबर",
  colRT_BenIfsc: "प्राप्तकर्ता IFSC",
  colRT_CBSrecDate: "CBS प्राप्त तिथि",
  colRT_CBSsendDt: "CBS भेजी गई तिथि",
  colRT_CBSRRN: "CBS RRN",
  colRT_RemCode: "भेजने वाले का कोड",
  colRT_RemMobNo: "भेजने वाले का मोबाइल नंबर",
  colRT_Status: "स्थिति",
  colRT_Narration: "विवरण",
  colRT_Renarks: "टिप्पणी",
  colRT_UploadedBy: "अपलोड किया गया द्वारा",
  colRT_UploadedDate: "अपलोड की गई तिथि",
  colRT_CheckedBy: "जाँचा गया द्वारा",
  colRT_CheckedDate: "जाँच की गई तिथि",
  colRT_AuthBy: "प्रमाणित किया गया द्वारा",
  colRT_AuthDate: "प्रमाणन तिथि",
  colRT_RejectedBy: "अस्वीकृत किया गया द्वारा",
  colRT_RejectedDate: "अस्वीकृति तिथि",
  applyButtonChecker: "लागू करें",

  // Beneficiary Authorize
  beneficiary_List: "लाभार्थी सूची",
  colBenAuthorizeNickname: "निकनेम",
  colBenAuthorizeName: "नाम",
  colBenAuthorizeAccNum: "खाता नंबर",
  colBenAuthorizeIFSC: "IFSC",
  colBenAuthorizeDelete: "हटाएं",
  AuthDenyButton: "प्रमाणित करें/अस्वीकृत करें",
  AuthDenyConfirmationMessage: "क्या आप वाकई लाभार्थी को प्रमाणित/अस्वीकृत करना चाहते हैं?",

  // Checker Transaction Report
  CHTranxReportHeading: "लेन-देन रिपोर्ट",
  CHTranxReportFromDate: "आरंभ तिथि",
  CHTranxReportToDate: "समाप्ति तिथि",
  CHTranxReportTType: "लेन-देन का प्रकार",
  CHTranxReportTTypeReq: "लेन-देन का प्रकार आवश्यक है",
  CHTranxReportStatus: "स्थिति",
  CHTranxReportStatusPlaceholder: "स्थिति चुनें",

  //Bulk Payment Preview
  BulkPaymentPreviewHeading: "बल्क पेमेंट पूर्वावलोकन",
  RecentBulkUploadTransaction: "हाल की बल्क अपलोड लेन-देन",

  //Transaction Approve
  TransactionApproveHeading: "लेन-देन अनुमोदन",
  SortPage: "पृष्ठ छाँटें",
  NoOfRecords: "रिकॉर्ड की संख्या",
  APPROVEDENYButton: "अनुमोदन करें / अस्वीकार करें",
  AUTHORIZEDENYButton: "प्राधिकृत करें / अस्वीकार करें",

  //Transaction Authorize
  TransactionAuthorizeHeading: "लेन-देन प्राधिकृत करें",

  colViewUser: "देखें",
  colActiveInactiveUser: "सक्रिय / निष्क्रिय",
  colNameOfUser: "उपयोगकर्ता का नाम",
  colUserID: "यूज़र आईडी",
  colUserRole: "उपयोगकर्ता की भूमिका",
  colCorporateId: "कॉर्पोरेट आईडी",
  colCorporateName: "कॉर्पोरेट नाम",
  colEmailId: "ईमेल आईडी",
  colAddressUser: "पता",
  colMobileNoUser: "मोबाइल नंबर",
  colStatusUser: "स्थिति",
  colAuthStatusUser: "प्रमाणन स्थिति",
  colCreatedDateUser: "बनाने की तिथि",

  //Card Details
  card_Hi: "नमस्ते ",

  //CORPORATECARDDASHBOARD
  cor_card_hi: "नमस्ते, ",
  cor_card_Balance: "शेष राशि",


  OTP_heading: "कृपया ओटीपी दर्ज करें",
  OTP_mainHeading: "ओटीपी सत्यापन",
  otp_title: "हमने आपके नंबर पर भेजा गया सत्यापन कोड दर्ज करें।",
  otplimits: "आपके पास",
  otplimitstext: "प्रयास शेष हैं",
  otpSubmit: "जमा करें",

  //Routes
  routeHome: "मुख्य पृष्ठ",
  routeAccount: "खाता",
  routeSetCustLimit: "खाता सीमा सेट करें",
  routeViewStatement: "स्टेटमेंट देखें",
  routeBeneficiaryMaster: "प्राप्तकर्ता सूची",
  routeOtherBank: "अन्य बैंक",
  routeWithinbank: "बैंक के भीतर",
  routeFundTransfer: "धन स्थानांतरण",
  routeNEFTFundTransfer: "एनईएफटी",
  routeRTGSFundTransfer: "आरटीजीएस",
  routeSelfAccount: "स्वयं का खाता",
  routePyamentSuccess: "भुगतान सफल",
  routeNEFTDetails: "एनईएफटी विवरण",
  routeReceipt: "रसीद",
  routeRTGSDetails: "आरटीजीएस विवरण",
  routeInternalDetails: "आंतरिक विवरण",
  routeTransactionReceipt: "लेन-देन रसीद",
  routeTransferHistory: "स्थानांतरण इतिहास",
  routeCards: "कार्ड्स",
  routeLoans: "ऋण",
  routeloansFields: "ऋण फ़ील्ड",
  routeloansPayment: "ऋण भुगतान",
  routeLoansDETAILS: "ऋण विवरण",
  routeDisbursementDetails: "वितरण विवरण",
  routeRepaymentDetails: "पुनर्भुगतान विवरण",
  routeViewStmt: "स्टेटमेंट देखें",
  routeDeposit: "जमा",
  routeDepositAccDetails: "जमा खाता विवरण",
  routeInterestRate: "ब्याज दर",
  routeOpenNewDeposit: "नया जमा खोलें",
  routeStmts: "स्टेटमेंट",
  routeCheque: "चेक",
  routeRequest: "अनुरोध",
  routeStatus: "स्थिति",
  routeStopPayment: "भुगतान रोकें",
  routePositivePay: "पॉजिटिव पे",
  routeCertificattes: "प्रमाणपत्र",
  routeProfile: "प्रोफ़ाइल",
  routeCustSupport: "ग्राहक सहायता",
  routeRaiseComplaint: "शिकायत दर्ज करें",

  //Corporate Maker
  routeCorHome: "मुख्य पृष्ठ",
  routeCorAccount: "खाता",
  routeCorLimit: "खाता सीमा सेट करें",
  routeCorViewStmt: "स्टेटमेंट देखें",
  routeCorLoanDetails: "ऋण विवरण",
  routeCorBeneficiaryMaster: "प्राप्तकर्ता सूची",
  routeCorOtherBank: "अन्य बैंक जोड़ें",
  routeCorWithBank: "बैंक के भीतर जोड़ें",
  routeBrowse: "ब्राउज़ करें",
  routePayments: "भुगतान",
  routeCorFundTransfer: "धन स्थानांतरण",
  routeCorSelfAccount: "स्वयं का खाता",
  routeCorBulkPyment: "बल्क भुगतान अपलोड",
  routeCorTranxReport: "लेन-देन रिपोर्ट",
  routeBulkUploadPreview: "बल्क अपलोड पूर्वावलोकन",
  routeFundTransferPreview: "धन स्थानांतरण पूर्वावलोकन",
  routeBulkFundTransferpreview: "बल्क धन स्थानांतरण पूर्वावलोकन",
  routeCorLoans: "ऋण",
  routeloansFields: "ऋण फ़ील्ड",
  routeCorloansPayment: "ऋण भुगतान",
  routeCorLoansDETAILS: "ऋण विवरण",
  routeCorDisbursementDetails: "वितरण विवरण",
  routeCorRepaymentDetails: "पुनर्भुगतान विवरण",
  routeCorViewStmt: "स्टेटमेंट देखें",
  routeCorDeposit: "जमा",
  routeCorDepositAccDetails: "जमा खाता विवरण",
  routeCorInterestRate: "ब्याज दर",
  routeCorOpenNewDeposit: "नया जमा खोलें",
  routeCorStmts: "स्टेटमेंट",
  routeCorProfile: "प्रोफ़ाइल",
  routeCorUser: "उपयोगकर्ता",

  //Corporate Checker
  routeCorChckHome: "मुख्य पृष्ठ",
  routeCorAccount: "खाता",
  routeCorAccLimit: "खाता सीमा सेट करें",
  routeCorViewStmt: "स्टेटमेंट देखें",
  routeCorLoanDetails: "ऋण विवरण",
  routeCorTrxReport: "लेन-देन रिपोर्ट",
  routeCheckPreview: "चेकर पूर्वावलोकन रिकॉर्ड",
  routeCheckBulkPreview: "बल्क पूर्वावलोकन",
  routeCheckBulkFundTrasfer: "चेकर पूर्वावलोकन",
  routeCheckApprove: "चेकर स्वीकृति",
  routeCheckViewRecord: "चेकर रिकॉर्ड देखें",

  //Corporate Authorize
  routeAuthHome: "मुख्य पृष्ठ",
  routeAuthBulkPrevuew: "बल्क पूर्वावलोकन",
  routeAuthTransactionReport: "लेन-देन रिपोर्ट",
  routeAuthViewRecord: "चेकर रिकॉर्ड देखें",
  routeAuthBulkPreview: "बल्क पूर्वावलोकन",
  routeAuthPreview: "पूर्वावलोकन",
  routeAuthTranxAuth: "लेन-देन अनुमोदन",
  routeAuthApprove: "अनुमोदित करें",
  routeBenAuthorize: "प्राप्तकर्ता अनुमोदन",

  // Hindi translations
dashQuickTransfer: "त्वरित ट्रांसफर",
dashNotransactionsyet: "अभी तक कोई लेनदेन नहीं हुआ",
dashNotransactionsyetDesc: "आपका पहला लेनदेन होने के बाद, आप इसे यहां देख पाएंगे",
dashAddnew: "नया जोड़ें",
dashAccountstatement: "खाता विवरण",
dashQuickLinks: "त्वरित लिंक",
dashAccountdetails: "खाते का विवरण",
dashAccountstatements: "खाता विवरण",
dashFundtransfer: "फंड ट्रांसफर",
dashGenerateQRCode: "QR कोड जनरेट करें",
dashRecentTransactions: "हाल की लेनदेन",
dashSeeall: "सभी देखें",
dashCreateTransactions: "लेनदेन बनाएं"

};
